/* Shared modal focus trap.
 *
 * window.BookwormsFocus.trap(node, opts) -> { release }
 *   opts.initial - element to focus first (default: node's first focusable)
 *   opts.restore - element to focus on release (default: whatever had focus
 *                  before trap() was called)
 *
 * Cycles Tab/Shift-Tab inside `node` while trapped. MUST NOT touch Escape -
 * every caller keeps its own Escape handling; this only ever manages Tab.
 * Must load before assistant.js and walkable.js (both call it).
 */
(function () {
  "use strict";

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function focusables(node) {
    var list = node.querySelectorAll(FOCUSABLE);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) out.push(list[i]);
    }
    return out;
  }

  function trap(node, opts) {
    opts = opts || {};
    var restoreTo = opts.restore || document.activeElement;
    var initial = opts.initial || focusables(node)[0];
    if (initial) initial.focus();

    function onKeydown(e) {
      if (e.key !== "Tab") return;
      var items = focusables(node);
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      var inside = node.contains(document.activeElement);
      if (e.shiftKey) {
        if (!inside || document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (!inside || document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener("keydown", onKeydown);

    function release() {
      document.removeEventListener("keydown", onKeydown);
      if (restoreTo && restoreTo.focus) restoreTo.focus();
    }
    return { release: release };
  }

  window.BookwormsFocus = { trap: trap };
})();
